import React from 'react';
import { DepartmentHierarchyNodeFragmentFragment as DepartmentHierarchyNode } from 'graphql-common';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Chip, { ChipSizes } from '@lib/components/Chip/Chip';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import styles from '../DepartmentHierarchyView/DepartmentHierarchyView.module.scss';

type Props = {
  node: DepartmentHierarchyNode;
  isCurrent?: boolean;
  children?: React.ReactNode;
};

// Static counterpart to DepartmentHierarchyTreeNode: same chip/connector/
// expand-chevron styling, but the chevron is a decorative MaterialIcon
// (always "expanded", no click/rotation) since the chain is fully known
// upfront from form state — nothing to actually toggle. Chips aren't links
// either, since navigating away would drop unsaved form input.
export default function DepartmentResultingHierarchyNode({
  node,
  isCurrent,
  children,
}: Props) {
  return (
    <li className={styles.node}>
      <div className={styles.nodeRow}>
        {children ? (
          <span className={styles.toggleStatic}>
            <MaterialIcon icon="expand_more" size="md-16" />
          </span>
        ) : (
          <span className={styles.togglePlaceholder} />
        )}
        <div className={styles.label}>
          <Chip
            label={node.name}
            leftIcon="circle"
            size={ChipSizes.small}
            type={colorToChipType(node.color)}
            asBlockElement
            fill={isCurrent}
          />
        </div>
      </div>
      {children && <ul className={styles.children}>{children}</ul>}
    </li>
  );
}
